import { Typography } from '@jcm/design-system';
import { PieChart, Pie, Cell, Legend } from 'recharts';
import estilo from './index.module.scss';

const COLORS = ['#3EA26E', '#FAB35A', '#C00019', '#009697'];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const renderTextoLegendaColorido = (nomeLegenda: string, valor: any) => {
	return (
		<Typography.Label size='large' strong className={estilo.legendaGraficoTorta}>
			{nomeLegenda}: {valor.payload.payload.value}
		</Typography.Label>
	);
};

type PieChartCompProps = {
	data: { name: string; value: number }[];
};

export default function PieChartComp({ data }: PieChartCompProps) {
	if (data.every((d) => d.value === 0)) {
		return null;
	}

	return (
		<div className={estilo.pieChartContainer}>
			<PieChart width={250} height={300} className={estilo.graficoTorta}>
				<Pie
					data={data}
					cx='50%'
					cy='50%'
					labelLine={false}
					outerRadius={90}
					innerRadius={30}
					dataKey='value'
					className={estilo.pieEstilizado}
				>
					{data.map((entry, index) => (
						<Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} className={estilo.cellEstilizado} />
					))}
				</Pie>
				<Legend
					iconType='square'
					layout='vertical'
					verticalAlign='bottom'
					align='center'
					iconSize={14}
					formatter={renderTextoLegendaColorido}
					className={estilo.legendaEstilizada}
				/>
			</PieChart>
		</div>
	);
}
